import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// eslint-disable-next-line
import AlertListStore from './alert/list/AlertListStore';
// eslint-disable-next-line
import SensorListStore from './sensor/list/SensorListStore';
import SensorProvisioningStore from './sensor/provisioning/SensorProvisioningStore';
// eslint-disable-next-line
import ProfileStore from './settings/profile/ProfileStore';
// eslint-disable-next-line
import DashboardStore from './dashboard/DashboardStore';
// eslint-disable-next-line
import TaskBoardStore from './task/TaskBoardStore';
import { isEmpty } from 'lodash';
// eslint-disable-next-line
import StationListStore from './station/list/StationListStore';

Vue.use(Vuex);

const initialState = () => ({
  logged: false,
  course: {},
  userCourses: [],
  user: {},
  flag: null,
  menuPolicy: [],
  sensor: {}, // Store sensor selected on Sensor List
  station: {},
  showMenu: false,
  showBackground: false,
  alert: [], // Store sensor selected on Sensor List
  taskAlert: {},
  backgrounIndex: 0,
  backgroundImagesArray: [
    { imgSource: "https://groundworx-media.s3.amazonaws.com/images/app/background/1.jpg" },
    { imgSource: "https://groundworx-media.s3.amazonaws.com/images/app/background/2.jpg" },
    { imgSource: "https://groundworx-media.s3.amazonaws.com/images/app/background/3.jpg" },
  ]
});

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    AlertList: AlertListStore,
    SensorList: SensorListStore,
    SensorProvisioning: SensorProvisioningStore,
    Profile: ProfileStore,
    Dashboard: DashboardStore,
    TaskBoard: TaskBoardStore,
    StationList: StationListStore,
  },
  state: {
    ...initialState(),
  },
  getters: {
    /* = Computed properties, perfects to filter data an execute some calculation */
    getCourses(state) {
      return state.userCourses.map((course) => ({
        value: course,
        text: course.name,
      }));
    },
  },
  mutations: {
    setFlag(state, flag){
      state.flag = flag
    },
    setCourse(state, course) {
      state.course = course;
    },
    setUser(state, user) {
      state.user = user;
    },
    setLogged(state, logged) {
      state.logged = logged;
    },
    setMenuPolicy(state, menuPolicy) {
      state.menuPolicy = menuPolicy;
    },
    setSensor(state, sensor) {
      state.sensor = sensor;
    },
    setStation(state, station) {
      state.station = station;
    },
    setUserCourses(state, courses) {
      state.userCourses = courses;
    },
    setAlert(state, alert) {
      state.alert = alert;
    },
    setBackgrounIndex(state, index) {
      state.backgrounIndex = index;
    },
    updateUserCourse(state, {
      index,
      course,
    }) {
      state.user.golf_courses[index] = course;
    },
    setShowMenu(state, show) {
      state.showMenu = show;
    },
    setShowBackground(state, show) {
      state.showBackground = show;
    },
    setTaskAlert(state, task) {
      state.taskAlert = task;
    },
    reset(state) {
      Object.assign(state, {
        ...initialState(),
      });
    },
  },
  actions: {
    reset(context) {
      context.commit('reset');
    },

    changeBackground({ commit, state }) {
      if (state.backgroundImagesArray.length > 0) {
        let bgImage = document.getElementById('bg-image');
        bgImage.classList.add('bg-fadeOut')
        setTimeout(() => {
          bgImage.classList.remove('bg-fadeOut')
          bgImage.classList.add('bg-fadeIn')
          bgImage.style.backgroundImage =
            `linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url("${state.backgroundImagesArray[state.backgrounIndex].imgSource}") `;
          setTimeout(() => {
            bgImage.classList.remove('bg-fadeIn')
          }, 2000);
        }, 1000);
        if ((state.backgroundImagesArray.length - 1) > state.backgrounIndex) {
          commit('setBackgrounIndex', state.backgrounIndex + 1);
        } else {
          commit('setBackgrounIndex', 0);
        }
      }

    },

    closeMenu() {
      if (document.getElementById("gwSidebar").style.display !== 'none') {
        document.getElementsByClassName('navbar-toggler')[0].click();
      }
    },
  },
});
